<template>
  <div class="click-out-overlay"></div>
</template>

<style lang="scss">
  .click-out-overlay {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 50;
  }
</style>

<script>
  export default {
    name: 'clickout-overlay'
  }
</script>
